<template>
  <div class="form-input">
    <div class="wrapper-label">
      <label class="label-input" :class="{ 'label-disabled': isDisabled }">{{
        label
      }}</label>
    </div>
    <input
      type="text"
      class="input"
      @input="changeInput"
      :class="{ disabled: isDisabled }"
      :value="value"
      :disabled="isDisabled ? 1 : 0"
      autocomplete="off"
      @focus="focus"
      @blur="blur"
    />
    <p :class="hasError ? 'error' : 'no-error'">
      {{ hasError ? error.esMessage : "" }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { MessageError } from "@/business/shared/commons/validator/validatorsTypes";

export default defineComponent({
  name: "AdminInput",
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: Object as () => MessageError,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    function changeInput(event: any): void {
      const value = event.target.value;
      context.emit("update:text", value);
      change(value);
    }

    function change(value: string): void {
      context.emit("change", value);
    }

    function clickInfo(): void {
      context.emit("info");
    }

    function focus(): void {
      context.emit("focus");
    }

    function blur(): void {
      context.emit("blur");
    }

    return { changeInput, clickInfo, focus, blur };
  },
});
</script>

<style scoped lang="scss">
@import "src/generalStyle/controls/adminInput";
</style>
